import type { WebStorage } from 'redux-persist';

/**
 * redux-persist 用の localStorage アダプター。
 *
 * redux-persist 標準の `redux-persist/lib/storage` は、モジュール初期化時に
 * localStorage へテスト書き込みを行い、失敗すると「何もしない(no-op)ストレージ」へ
 * 黙ってフォールバックする。すると以降の書き込みは失敗として検知されず
 * (`writeFailHandler` が呼ばれない)、起動時点でストレージがブロックされている
 * (プライベートブラウジング等)場合に、保存できていないのに成功と扱われてしまう(PRISM-3110)。
 *
 * そのため、初期化時に判定せず、呼び出しのたびに localStorage を直接操作し、
 * 書き込み(`setItem`)の失敗だけを例外(Promiseのreject)として伝える。
 * 読み込み・削除の失敗は、標準のストレージと同様に握りつぶして起動を妨げない。
 */
export const localStorageAdapter: WebStorage = {
  getItem: (key) =>
    new Promise((resolve) => {
      try {
        resolve(window.localStorage.getItem(key));
      } catch {
        resolve(null);
      }
    }),
  setItem: (key, value) =>
    new Promise<void>((resolve) => {
      // 例外(QuotaExceededError, SecurityError等)はPromiseのrejectとして伝わる
      window.localStorage.setItem(key, value);
      resolve();
    }),
  removeItem: (key) =>
    new Promise<void>((resolve) => {
      try {
        window.localStorage.removeItem(key);
      } catch {
        // 削除の失敗は無視する
      }
      resolve();
    }),
};
